// export { default as HighVoltage } from './highVoltage'
// export { default as LowVoltage } from './lowVoltage'
export { default as DoubleDrainage } from './doubleDrainage'
export { default as ExhaustFan } from './exhaustFan'
export { default as ExhaustFanGroup } from './exhaustFanGroup'
export { default as SmokeFan } from './smokeFan'
export { default as AirUnit } from './airUnit'
export { default as HotAir } from './hotAir'
export { default as ParkingLotChart } from './parkingLotChart'
export { default as AccessControlChart } from './accessControlChart'
export { default as ElevatorDialog } from './elevatorDialog'
export { default as DoorChart } from './doorChart'

const resultComps = {}
let requireComponent = require.context(
    './', // 在当前目录下查找
    false, // 不遍历子文件夹
    /\.vue$/ // 正则匹配 以 .vue结尾的文件
)

requireComponent.keys().forEach(fileName => {
    let comp = requireComponent(fileName)
    resultComps[fileName.replace(/^\.\/(.*)\.\w+$/, '$1')] = comp.default
})
console.log(resultComps)
export default resultComps
